import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';

import { NutrientCategory } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected readonly http = inject(HttpClient);
  private readonly env = inject(EnvironmentInjector) as Environment;

  protected baseUrl = this.env.APIM_BASE_URL + '/labresult-v2-service/labresult-v2';

  getNutrientCategories(): Observable<NutrientCategory[]> {
    return this.http.get<NutrientCategory[]>(`${this.baseUrl}/nutrients/categories`);
  }
}
